// ============================================================================
// ALERT — canal « alerte » (§24.1quater A) : une action a ÉCHOUÉ (message RÉEL, §23.0) ou accusé de
// réception bloquant. Pendant exact de `@orgazone/ui-native/alert` — signature IDENTIQUE :
// `await alert(opts) → void`. Rendu par `<DialogHost/>` (dialog.tsx).
// ⚠️ C'est ICI que va une erreur — jamais dans un toast (une erreur qui s'efface seule est perdue).
// ============================================================================
import { type AlertTone } from '@orgazone/ui-tokens';
import { pushDialog } from './dialog';

export interface AlertOptions {
  /** Ce qui a échoué (ou ce dont on accuse réception), côté utilisateur. */
  title: string;
  /** Le message RÉEL de l'échec (l'exception, la réponse serveur) — jamais un texte rassurant inventé. */
  message?: string;
  /** Défaut « Fermer » (tokens). */
  closeLabel?: string;
  /** `err` (défaut) = échec ; `info` = accusé de réception. */
  tone?: AlertTone;
}

/** Affiche l'alerte et rend la main quand l'utilisateur l'a fermée (Échap/Entrée/voile/bouton). */
export async function alert(opts: AlertOptions): Promise<void> {
  await pushDialog('alert', { confirmLabel: '', ...opts });
}
